import React, { SyntheticEvent, useEffect, useState } from 'react'
import {
  Header,
  Segment,
  Form,
  Item,
  DropdownProps,
  Grid,
  ItemDescription,
  Label,
} from 'semantic-ui-react'

import { Localization } from '../../hooks/useLocalizations'
import { localizationListToSubdivisionOptions } from '../../utils/localizations/localizationOptions'

const EMPTY_VALUE_ALT_TEXT = 'Jane Default'

const DefaultLabel = () => {
  return <Label color="violet">{EMPTY_VALUE_ALT_TEXT}</Label>
}

const displayValue = (value: string | undefined | null) => {
  if (typeof value === 'string') {
    return value
  }

  return DefaultLabel
}

export const ReadOnlyLocalizations = ({ localizations }: { localizations?: Localization[] }) => {
  const [currentLocalization, setCurrentLocalization] = useState<undefined | Localization>(
    undefined
  )

  useEffect(() => {
    setCurrentLocalization(localizations?.[0])
  }, [localizations])

  const subdivisionOptions = localizationListToSubdivisionOptions(localizations)

  const handleChangeLocalization = (e: SyntheticEvent, data: DropdownProps) => {
    const selectedLocalizationId = data.value
    setCurrentLocalization(
      localizations?.find((el: Localization) => el.id === selectedLocalizationId)
    )
  }

  return (
    <>
      <Segment attached="top">
        <Header style={{ margin: 0 }} as="h3">
          State-Specific Content
        </Header>
        <Header.Subheader style={{ color: 'gray' }}>
          {localizations
            ?.map(
              (localization: Localization) => `${localization.country}-${localization.subdivision}`
            )
            .sort()
            .join(', ')}
        </Header.Subheader>
      </Segment>
      <Segment attached>
        {localizations && localizations.length > 0 ? (
          <>
            <Form>
              <Form.Dropdown
                label="Select a state:"
                selection
                inline
                placeholder="State"
                options={subdivisionOptions || []}
                onChange={handleChangeLocalization}
                value={currentLocalization?.id}
              />
            </Form>

            <Item.Group>
              <Item>
                <Item.Content>
                  <Item.Header>Name</Item.Header>
                  <Item.Description>{displayValue(currentLocalization?.name)}</Item.Description>
                </Item.Content>
              </Item>
              <Item>
                <Item.Content>
                  <Item.Header>Description</Item.Header>
                  <Item.Description>
                    {displayValue(currentLocalization?.description)}
                  </Item.Description>
                </Item.Content>
              </Item>
              <Item>
                <Item.Content>
                  <Item.Header>Lineage</Item.Header>
                  <Item.Description>{displayValue(currentLocalization?.lineage)}</Item.Description>
                </Item.Content>
              </Item>
              <Item>
                <Item.Content>
                  <Item.Header>Brand Subtype</Item.Header>
                  <Item.Description>
                    {displayValue(currentLocalization?.category_label)}
                  </Item.Description>
                </Item.Content>
              </Item>
              <Item>
                <Item.Content>
                  <Item.Header>Photos</Item.Header>
                  {currentLocalization?.images ? (
                    <Item.Description>
                      <Grid relaxed>
                        {currentLocalization?.images.length === 0 ? (
                          <Grid.Column
                            style={{
                              minWidth: 180,
                              flexGrow: 0,
                              flexShrink: 1,
                              flexBasis: 'min-content',
                            }}
                          ></Grid.Column>
                        ) : (
                          currentLocalization?.images?.map((url) => {
                            return (
                              <Grid.Column
                                key={url}
                                style={{
                                  minWidth: 180,
                                  flexGrow: 0,
                                  flexShrink: 1,
                                  flexBasis: 'min-content',
                                }}
                              >
                                <img src={url} width="100%" alt="" />
                              </Grid.Column>
                            )
                          })
                        )}
                      </Grid>
                    </Item.Description>
                  ) : (
                    <ItemDescription>
                      <DefaultLabel />
                    </ItemDescription>
                  )}
                </Item.Content>
              </Item>
            </Item.Group>
          </>
        ) : (
          <Item.Group>
            <Item>
              <Item.Content>No state-specific content to display for this product</Item.Content>
            </Item>
          </Item.Group>
        )}
      </Segment>
    </>
  )
}
